import './content-divider.scss';
import React from 'react';

import { IClassNames, makeClassNames } from '../../../utils/styles';

const classNames = (customClass?: string): IClassNames =>
  makeClassNames({
    contentDivider: `content-divider ${customClass}`,
  });

interface IContentDivider {
  customClass?: string;
}
const ContentDivider: React.FC<IContentDivider> = ({ customClass }: { customClass?: string }) => (
  <div className={classNames(customClass as string).contentDivider} />
);

export default ContentDivider;
